import React from "react";
import Button from "../../../shared/components/Button/Button";
import { useBlingProductSync } from "../hooks/useBlingProductSync";
import { useBlingStockSync } from "../hooks/useBlingStockSync";

const ErrorList = ({ errors }) =>
  errors.length > 0 && (
    <ul className="bling-page__errors">
      {errors.map((e, i) => (
        <li key={`${e.code}-${i}`}>
          <strong>{e.code}</strong>: {e.error}
        </li>
      ))}
    </ul>
  );

// Site → Bling: cadastro (com fotos e variação cor × tamanho) e estoque.
const BlingProductSyncPanel = ({ disabled }) => {
  const products = useBlingProductSync();
  const stock = useBlingStockSync();
  const busy = products.syncing || stock.syncing;

  return (
    <div className="bling-page__panel">
      <h5>Produtos e estoque</h5>
      <p className="text-muted bling-page__hint">
        O site é a fonte da verdade. <strong>Enviar produtos</strong> manda os
        produtos novos ou alterados (fotos de cada cor, NCM, variações e
        estoque) e inativa no Bling os excluídos aqui.{" "}
        <strong>Enviar estoque</strong> acerta o saldo de todos os produtos e
        recria as variações que mudaram de cor ou tamanho.
      </p>
      <div className="bling-page__actions">
        <Button onClick={products.start} disabled={disabled || busy}>
          {products.syncing ? "Enviando produtos…" : "Enviar produtos"}
        </Button>
        <Button
          variant="secondary"
          onClick={stock.start}
          disabled={disabled || busy}
        >
          {stock.syncing ? "Enviando estoque…" : "Enviar estoque"}
        </Button>
      </div>

      {(products.synced > 0 || products.remaining !== null) && (
        <p className="mt-3 mb-1">
          Produtos: <strong>{products.synced}</strong> enviados
          {products.remaining ? ` · ${products.remaining} restantes` : ""}
        </p>
      )}
      <ErrorList errors={products.errors} />

      {(stock.processed > 0 || stock.remaining !== null) && (
        <p className="mt-3 mb-1">
          Estoque: <strong>{stock.processed}</strong> produtos conferidos ·{" "}
          <strong>{stock.updated}</strong> saldos atualizados
          {stock.remaining ? ` · ${stock.remaining} restantes` : ""}
        </p>
      )}
      <ErrorList errors={stock.errors} />
    </div>
  );
};

export default BlingProductSyncPanel;
